import { render } from "./ylyOrganizationTree.vue?vue&type=template&id=2e5ffdc4&scoped=true"
import script from "./ylyOrganizationTree.vue?vue&type=script&lang=js"
export * from "./ylyOrganizationTree.vue?vue&type=script&lang=js"

import "./ylyOrganizationTree.vue?vue&type=style&index=0&id=2e5ffdc4&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5ffdc4"]])

export default __exports__